import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DetailForm from './components/DetailForm.vue'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuActivityCodeView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, { style: {"margin-top":"0"} }, {
            default: _withCtx(() => [
              _createVNode(DetailForm, {
                type: "view",
                title: _unref(t)('marketing.市场活动详情'),
                paramCode: "ofbu_source_channel",
                subdomain: "ofbu"
              }, null, 8, ["title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})